<template>
  <div class="form-group flex m-2 mt-5 justify-center">
    <img src="@/assets/key.svg" class="w-6 mr-4" />
    <div class="code-input">
      <input
        id="firstDigit"
        ref="digit1"
        v-model="firstDigit"
        class="digit"
        autocomplete="off"
        :maxlength="currentDigit === 1 ? 5 : 1"
        @input="changeFocusForward"
        @focus="currentDigit = 1"
        inputmode="numeric"
      />
      <input
        id="secondDigit"
        ref="digit2"
        v-model="secondDigit"
        class="digit"
        autocomplete="off"
        maxlength="1"
        @focus="currentDigit = 2"
        @input="changeFocusForward"
        inputmode="numeric"
      />
      <input
        id="thirdDigit"
        ref="digit3"
        v-model="thirdDigit"
        class="digit"
        autocomplete="off"
        maxlength="1"
        @focus="currentDigit = 3"
        @input="changeFocusForward"
        inputmode="numeric"
      />
      <input
        id="fourthDigit"
        ref="digit4"
        v-model="fourthDigit"
        class="digit"
        autocomplete="off"
        maxlength="1"
        @focus="currentDigit = 4"
        @input="changeFocusForward"
        inputmode="numeric"
      />
      <input
        id="fifthDigit"
        ref="digit5"
        v-model="fifthDigit"
        class="digit"
        autocomplete="off"
        maxlength="1"
        @focus="currentDigit = 5"
        @input="changeFocusForward"
        inputmode="numeric"
      />
    </div>
  </div>
  <CountdownTimer />
</template>

<script>
import emitter from '@/utils/events';
import CountdownTimer from './CountdownTimer.vue';

export default {
  props: {
    code: {
      type: String,
      required: true,
    },
  },
  components: {
    CountdownTimer,
  },
  data() {
    return {
      firstDigit: '',
      secondDigit: '',
      thirdDigit: '',
      fourthDigit: '',
      fifthDigit: '',
      currentDigit: 1,
    };
  },
  computed: {
    fullCode() {
      return [
        this.firstDigit,
        this.secondDigit,
        this.thirdDigit,
        this.fourthDigit,
        this.fifthDigit,
      ].join('');
    },
  },
  methods: {
    setCode(value) {
      this.$emit('update:code', value);
    },
    changeFocus(digit) {
      this.$refs[`digit${digit}`].focus();
    },
    changeFocusForward(event) {
      if (!/[0-9]*/.test(event.target.value)) {
        this[event.target.id] = '';
        return;
      } else if (this.currentDigit === 1 && event.target.value.length === 5) {
        this.firstDigit = event.target.value[0];
        this.secondDigit = event.target.value[1];
        this.thirdDigit = event.target.value[2];
        this.fourthDigit = event.target.value[3];
        this.fifthDigit = event.target.value[4];
      } else if (this.currentDigit < 5) {
        this.changeFocus(++this.currentDigit);
      }
      this.setCode(this.fullCode);
    },
    clear() {
      this.firstDigit = '';
      this.secondDigit = '';
      this.thirdDigit = '';
      this.fourthDigit = '';
      this.fifthDigit = '';
    },
  },
  mounted() {
    emitter.on('clear-codeInput', () => {
      this.clear();
    });
  },
  unmounted() {
    emitter.off('clear-codeInput');
  },
};
</script>

<style lang="scss" scoped>
.code-input {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(5, 40px);
  justify-content: space-between;
  height: 50px;
  > .digit {
    @apply border-blue-100 border-2;
    border-radius: 5px;
    text-align: center;
    font-size: 22px;
  }
}
</style>
